import { useMutation } from "react-query";
import { fetchReferralshWithRecaptcha } from "services/api";
import { IPostReferrals } from "services/IApi";

interface MutationsParams {
  token: string;
  data: IPostReferrals
}

const referralshWithRecaptcha = async (dataRequest: MutationsParams) =>  fetchReferralshWithRecaptcha(dataRequest.data, dataRequest.token)  

export default function usePostReferralshWithRecaptcha() {
  return useMutation( referralshWithRecaptcha );
}
